import React from 'react'
import '@usb-shield/react-link/dist/library/styles/index.css'
import '@usb-shield/react-grid/dist/library/styles/index.css'
import 'highlight.js/styles/default.css'
import USBButton from '@usb-shield/react-button'
import styles from '@/modules/products/ProductDocumentPage/components/ProductSections/productSectionsDownload.module.scss'
import dynamic from 'next/dynamic'
import { ProductSectionsDownloadProps } from '@/modules/products/ProductDocumentPage/components/ProductSections/ProductSectionsDownloadModel'
import '@usb-shield/react-modal/dist/library/styles/index.css'
import { downloadDocument } from '@/modules/products/ProductOverviewPage/services/productSectionsDownload.service'

const ReactMarkDown = dynamic(
  () => import('@/components/ReactMarkDown/ReactMarkDown'),
  {
    ssr: false,
  }
)

/**
 * Component for rendering a product section with a markdown description and a download button.
 *
 * @param {ProductSectionsDownloadProps} props - The props for the component.
 * @param {Object} props.ProductSectionsContent - The content for the product section.
 * @param {string} [props.ProductSectionsContent.downloadButtonName] - The text to display on the download button.
 * @param {string} [props.ProductSectionsContent.downloadLink] - The URL to open when the download button is clicked.
 * @param {string} [props.ProductSectionsContent.markdown] - The markdown content to render in the section.
 *
 * @returns {JSX.Element} The rendered product section with markdown and a download button.
 */
const ProductSectionsDownload = ({
  ProductSectionsContent,
}: ProductSectionsDownloadProps): JSX.Element => {
  const {
    downloadButtonName: PRODUCT_DOWNLOAD_TEXT = '',
    downloadLink: PRODUCT_DOWNLOAD_LINK = '',
    download: { body: MARKDOWN_CONTENT = '' } = {},
  } = ProductSectionsContent
  const PRODUCT_DOWNLOAD_URL = `${process.env.CONTENT_DOMAIN}/${PRODUCT_DOWNLOAD_LINK}`
  const DOC_NAME = PRODUCT_DOWNLOAD_LINK.split('/').pop() || ''

  const HANDLE_DOWNLOAD_CLICK = (): void => {
    downloadDocument(PRODUCT_DOWNLOAD_URL, DOC_NAME)
  }

  return (
    <>
      <ReactMarkDown content={MARKDOWN_CONTENT} />
      <USBButton
        addClasses={styles.buttonStyling}
        emphasis="subtle"
        id="product-sections-download-button"
        handleClick={HANDLE_DOWNLOAD_CLICK}
      >
        {PRODUCT_DOWNLOAD_TEXT}
      </USBButton>
    </>
  )
}

export default ProductSectionsDownload
